import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "goods-title" }
const _hoisted_2 = {
  key: 0,
  class: "goods-desc"
}
const _hoisted_3 = {
  key: 1,
  class: "empty-tip"
}
const _hoisted_4 = { class: "group-name" }

import { computed, reactive, watch } from 'vue';
import { buildSelectedSpecs, getGoodsSpecText, normalizeGoodsSpecs, type GoodsSpec, type SelectedGoodsSpec } from '@/utils/goodsSpecs';

interface GoodsItem {
  id: number;
  name: string;
  description?: string;
  specs?: GoodsSpec[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'goods-spec-select-dialog',
  props: {
    visible: { type: Boolean },
    goods: {},
    initialSelectedSpecs: {}
  },
  emits: ["update:visible", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const selectedValueMap = reactive<Record<string, string>>({});

const specs = computed(() => normalizeGoodsSpecs(props.goods?.specs || []));

const syncSelections = () => {
  Object.keys(selectedValueMap).forEach((key) => delete selectedValueMap[key]);
  const selectedSpecs = buildSelectedSpecs(specs.value, props.initialSelectedSpecs || []);
  selectedSpecs.forEach((item) => {
    selectedValueMap[item.name] = item.value;
  });
};

watch(() => [props.visible, props.goods, props.initialSelectedSpecs], () => {
  if (props.visible) {
    syncSelections();
  }
}, { immediate: true, deep: true });

const handleClose = () => {
  emit('update:visible', false);
};

const handleConfirm = () => {
  const selectedSpecs = specs.value.map((item) => ({
    name: item.name,
    value: selectedValueMap[item.name] || item.options[0],
  }));
  emit('confirm', {
    selectedSpecs,
    specText: getGoodsSpecText({ selectedSpecs }),
  });
  emit('update:visible', false);
};

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    title: "选择规格",
    width: "520px",
    "append-to-body": "",
    "close-on-click-modal": false,
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: handleClose }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("取消", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleConfirm
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("确定", -1)
        ]))]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (__props.goods)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(__props.goods.name), 1),
            (__props.goods.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.goods.description), 1))
              : _createCommentVNode("", true),
            (specs.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "该商品未配置规格"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specs.value, (group, groupIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: groupIndex,
                class: "spec-group"
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(group.name), 1),
                _createVNode(_component_el_radio_group, {
                  modelValue: selectedValueMap[group.name],
                  "onUpdate:modelValue": ($event: any) => ((selectedValueMap[group.name]) = $event),
                  class: "option-list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (option) => {
                      return (_openBlock(), _createBlock(_component_el_radio_button, {
                        key: option,
                        label: option
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})